<template>
  <div class="contact-main">
    <img
      src="@/assets/images/contact/join-banner.png"
      class="contact-banner"
      alt=""
    />
    <div class="content">
      <div class="title">加入博智林</div>
      <div
        class="content-list"
        v-for="(item, index) in contactList"
        :key="index"
      >
        <router-link :to="{ path: item.path }">
          <div class="list-item">
            <div :style="{ position: 'relative' }">
              <img :src="item.imgUrl" class="list-image" alt="" />
              <div class="list-meta">
                <div class="meta-title">{{ item.content }}</div>
                <img
                  src="@/assets/images/contact/arrow.png"
                  class="jump-arrow"
                  alt=""
                />
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "join",
  data() {
    return {
      contactList: [
        {
          imgUrl: require("@/assets/images/contact/recruit.png"),
          content: "人才招募",
          path: "/recruit",
        },
        {
          imgUrl: require("@/assets/images/contact/staff-life.png"),
          content: "员工生活",
          path: "/life",
        },
        {
          imgUrl: require("@/assets/images/contact/train.png"),
          content: "员工培养",
          path: "/train",
        },
      ],
    };
  },
};
</script>
<style  scoped>
.contact-banner {
  width: 100%;
}
.content {
  padding: 48px 48px 132px 48px;
}
.content .title {
  font-size: 48px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  line-height: 68px;
}
.list-item {
  display: flex;
  height: 347px;
  margin-top: 32px;
}

.list-image {
  width: 100%;
}

.list-meta {
  position: absolute;
  left: 60px;
  bottom: 60px;
  display: flex;
  align-items: center;
}
.meta-title {
  font-size: 42px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ffffff;
  line-height: 48px;
}
.list-meta .jump-arrow {
  width: 36px;
  height: 36px;
}
</style>
